import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type { DataTableDto, DataTablePayload } from '@app/assets/dataset/dataset.dto';
import { DATA_TABLE_PATH } from '@app/shared/api/api-route.config';
import { type ListResponse, WithCrudService } from '@app/shared/api/crud.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';

@Injectable({
    providedIn: 'root',
})
export class DataTableService extends classes(
    WithLogService,
    WithLineageService,
    WithCrudService<DataTableDto>,
) {
    protected endpoint = DATA_TABLE_PATH;

    protected readonly api = inject(RestService);

    getAll(params = {}): Observable<ListResponse<DataTableDto>> {
        return this.api.getWithParams(this.endpoint, params);
    }

    previewData(
        dataTableId: number,
        params: {
            query: string;
            isDefaultQuery: boolean;
        },
        options?: { transactionId: number },
    ): Observable<{
        result: {
            data: { columns: string[]; data: string[][]; metadata?: { fetchedAt: string } };
            logs?: string;
        };
    }> {
        const url = this.constructURL(`${this.endpoint}${dataTableId}`, options?.transactionId);
        return this.api.post(`${url}/preview_data`, params);
    }

    previewUnsavedData(dataTable: DataTablePayload): Observable<{
        result: {
            data: { columns: string[]; data: string[][]; metadata?: { fetchedAt: string } };
            logs?: string;
        };
    }> {
        return this.api.post(`${this.endpoint}preview_data`, dataTable);
    }
}
